module.exports = __webpack_public_path__ + "static/img/user12.f5b9eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user12.jpg
// module id = ve1W
// module chunks = 23